import { render, staticRenderFns } from "./bscHhptInventoryRecord.vue?vue&type=template&id=fc18fce2&scoped=true"
import script from "./bscHhptInventoryRecord.vue?vue&type=script&lang=js"
export * from "./bscHhptInventoryRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc18fce2",
  null
  
)

export default component.exports